import React from 'react'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import { CardHeader } from '@material-ui/core'
import PageInfo from '../../../../PageInfo/PageInfo'

const AssignmentHeader = () => {
  return <CardHeader title={<PageInfo pageTranslateKey={'assignment'} />} />
}

export default withTranslate(AssignmentHeader)
